import { Component, OnInit } from '@angular/core';
import { ObjectLayoutWidget } from 'ngx-schema-form';
import { Pipe, PipeTransform } from '@angular/core';

export let getMultilangSchemaForm = function (title: string) {
    return {
        type: 'object',
        widget: 'multilang',
        title: title,
        properties: {
            it: {
                type: 'string',
                title: title,
            },
            en: {
                type: 'string',
                title: title,
            },
            fr: {
                type: 'string',
                title: title,
            },
            es: {
                type: 'string',
                title: title,
            },
            sq: {
                type: 'string',
                title: title,
            },
            ar: {
                type: 'string',
                title: title,
            },
            zh: {
                type: 'string',
                title: title,
            },
            ro: {
                type: 'string',
                title: title,
            },
        },
    };
};



@Component({
    selector: 'sf-demo-wizard-widget',
    templateUrl: './multilang-string.widget.html',
    styleUrls: ['./multilang-string.widget.css'],
})
export class MultilangStringWidget extends ObjectLayoutWidget
    implements OnInit {
    private currentPage = null;

    ngOnInit() {
        this.currentPage = 0;
    }

    titleForProperty = function (key) {
        return this.schema.properties[key].title;
    };
}
